import { render } from "./WCAvaliableCoupons.vue?vue&type=template&id=36daca15"
import script from "./WCAvaliableCoupons.vue?vue&type=script&lang=js"
export * from "./WCAvaliableCoupons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__